export function withFromInbox(path, isFromInbox = true) {
  let search = '?';
  if (path.endsWith('?')) {
    search = '';
  } else if (path.includes('?')) {
    search = '&';
  }
  return `${path}${search}fromInbox=${isFromInbox}`;
}